// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/ajax-sales');
require('@js/ajax-home');
require('@js/ajax-tools');
require('@js/copy');
require('@js/video-play');
require('@js/video-play');
require('@js/like-post');
require('@js/search');
require('@js/select');
require('@js/swiper');
require('@js/lock-form');
// require('@js/quote-button');
// require('@js/video-button');
